import React from "react";
import loginBg from "../../assets/images/login-bg.png";
import px1shadow from "../../assets/images/px1-shadow.png";
import LoginForm from "../../components/auth/LoginForm";

export default function LoginPage() {
  return (
    <div>
      <div className="grid lg:grid-cols-2 ">
        <LoginForm />
        <div
          className="hidden lg:block h-navbar bg-cover"
          style={{ backgroundImage: `url(${loginBg})` }}
        >
          <div className="grid h-navbar place-items-center ">
            <img alt="PX1" src={px1shadow} className="z-10" />
          </div>
        </div>
      </div>
    </div>
  );
}
